
<div class="d-flex video-container">
  @if (aiLoading || splitVideoLoading || transcriptionCheck) {
    <div class="workflow-background"></div>
  }
  @if (aiLoading || splitVideoLoading || transcriptionCheck) {
    <div class="loading-process">
      <div>
        <ng-lottie [options]="optionsi" (animationCreated)="animationCreated($event)" style="width: 100%; height: 225px;"></ng-lottie>
        <div class="fs-14 font-weight-500 ai-text">
          @if (aiLoading) {
            <p>{{ 'MAIN.CONTENT.VIDEO-FLOW-DASHBOARD.AI-PROCESSING' | translate }} <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></p>
          }
          @if (splitVideoLoading) {
            <p>{{ 'MAIN.CONTENT.VIDEO-FLOW-DASHBOARD.SPLITTING-VIDEO' | translate }} <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></p>
          }
          @if (transcriptionCheck) {
            <p>{{ 'MAIN.CONTENT.VIDEO-FLOW-DASHBOARD.TRANSCRIBING-VIDEO' | translate }} <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></p>
          }
          @if (aiLoading || splitVideoLoading || transcriptionCheck) {
            <p class="fixed-text fs-13">
              {{ 'MAIN.CONTENT.VIDEO-FLOW-DASHBOARD.PROCESS-WARNING' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
  }

  <div class="col-2" style="width: 240px;height: 100%;z-index: 500;background-color: white;">
    <div class="step-list">
      <app-step-list
        [type]="type"
        [stepSelected]="stepSelectedByVideoTimeline"
        [(stepList)]="workflowSteps"
        [connectionEnabled]="false"
        [initialStep]="initialStep"
        [isVideoFlow]= "true"
        (selectedStepChange)="selectedStepChange($event)"
        (stepListChange)="stepListChange($event)"
        [(workflowTranslations)]="workflowTranslations"
        (onStepRename)="onStepRename($event)"
      ></app-step-list>
    </div>
  </div>
  <div class="col-6 pt-4 steps-detail" cdkDropListGroup >
    <div #scrollContainer>
      @for (chapter of videoChapters; track chapterTrackByFn(chapterIndex, chapter); let chapterIndex = $index) {
        <div class="d-flex flex-column">
          <div class="d-flex flex-column" style="padding-top: 0px;">
            <div class="d-flex">
              <p class="fs-15 font-weight-600" style="padding-left:20px;">{{ chapter.timestampStart }}</p>
              <p class="fs-14 font-weight-700" style="padding-left:20px;">{{ chapter.title }}
                <span class="play-buttons cursor-pointer" (click)="playVideo(chapter)">
                  <img src="assets/img/play-circle.svg" alt="" class="ms-2 play-button">
                  <img src="assets/img/play-circle-hover.svg" alt="" class="ms-2 play-hover">
                </span>
              </p>
            </div>
            <div class="step-container"
              cdkDropList
              cdkDropListAxis="y"
              [cdkDropListData]="chapter"
              (cdkDropListDropped)="dropStep($event)">
              @for (step of chapter.steps; track trackByFn(stepIndex, step); let stepIndex = $index) {
                <div class="step" >
                  <div class="d-flex align-items-start" style="padding-left: 96px; padding-right: 45px;">
                    <!-- View Mode -->
                    @if (!isStepEditing(chapterIndex, stepIndex)) {
                      <p class="step-description fs-14 font-weight-400 mb-0 flex-grow-1">
                        {{ getStepText(step) }}
                      </p>
                    }
                    <!-- Edit Mode -->
                    @if (isStepEditing(chapterIndex, stepIndex)) {
                      <textarea
                        [(ngModel)]="editedStepText"
                        class="form-control fs-14 flex-grow-1"
                        rows="2"
                        style="resize: vertical;"
                        [attr.disabled]="type == 'published' ? true : null">
                      </textarea>
                    }
                    <!-- Edit Button (only show in non-published mode) -->
                    @if (!isStepEditing(chapterIndex, stepIndex) && type !== 'published') {
                      <button
                        (click)="startEditingStep(chapterIndex, stepIndex, step)"
                        class="btn btn-sm btn-link p-0 ms-2"
                        style="min-width: 24px;"
                        title="Edit description">
                        <img src="assets/img/edit_image.svg" alt="Edit" style="width: 16px; height: 16px;">
                      </button>
                    }
                    <!-- Approve Button -->
                    @if (isStepEditing(chapterIndex, stepIndex)) {
                      <button
                        (click)="approveStepEdit(chapterIndex, stepIndex, step)"
                        class="btn btn-sm btn-primary ms-2"
                        style="min-width: 70px;"
                        title="Approve changes">
                        {{ 'MAIN.CONTENT.WORKFLOW.APPROVE' | translate }}
                      </button>
                    }
                    <!-- Cancel Button -->
                    @if (isStepEditing(chapterIndex, stepIndex)) {
                      <button
                        (click)="cancelEditingStep()"
                        class="btn btn-sm btn-secondary ms-1"
                        title="Cancel editing">
                        {{ 'MAIN.CONTENT.WORKFLOW.CANCEL' | translate }}
                      </button>
                    }
                  </div>
                  <div class="p-relative divider-step" [attr.id]="step.uuid" cdkDrag [cdkDragData]="chapter" [ngClass]="{'has-divider': stepIndex !== chapter.steps.length-1 }" [ngStyle]="{'pointer-events': type == 'published' ? 'none' : ''}">
                    @if (stepIndex !== chapter.steps.length-1) {
                      <img src="assets/img/step-cut-icon.svg" alt="" height="20px" class="divider-icon-step-cut" (click)="divideSteps(chapterIndex, stepIndex)">
                      <hr class="step-line selected-step-line-cut">
                    }
                    @if (stepIndex == chapter.steps.length-1) {
                      <img src="assets/img/step-divider-icon.svg" alt="" height="20px" class="divider-icon-step">
                      <hr class="step-line selected-step-line">
                    }
                  </div>
                </div>
              }
            </div>
            <!-- <div class="col-2 fs-14 font-weight-600">{{chapter.title}}</div>
            <div *ngIf="chapter.text" class="col-10 fs-14">{{videoChapters}}</div> -->
          </div>
          <!-- <div class="p-relative divider" cdkDrag>
          <img src="assets/img/step-divider-icon.svg" alt="" height="20px" class="divider-icon">
          <hr class="step-line selected-step-line" >
        </div> -->
      </div>
    }
  </div>
</div>

<div class="preview-part col-4" style="background-color: #e1e1e1;">
  <div class="d-flex flex-column">
    <div class="col-6 d-flex align-items-center justify-content-center w-100">
      @if (mainVideoUrl) {
        <div class="mt-2">
          <!-- <video controls playsinline muted class="form-video" #myVideoElement>
          <source [src]="videoUrl | safeHtml" type="video/mp4" />
        </video> -->
        <video [src]="mainVideoUrl | safeHtml" controls class="form-video" #myVideoElement>
          <!-- <track kind="subtitles" [src]="captionUrl" srclang="en" label="English"> -->
        </video>
      </div>
    }
  </div>
</div>
</div>

</div>